import React, { useState, useEffect } from 'react';

export default function ConfiguracionesModal({ open, mode, data, onClose, onSubmit, inline, empresas = [] }) {
    const [form, setForm] = useState({
        nombre: '',
        descripcion: '',
        valor: '',
        idEmpresa: '',
        activo: true
    });

    useEffect(() => {
        if (mode === 'edit' && data) {
            setForm({
                nombre: data.nombre || '',
                descripcion: data.descripcion || '',
                valor: data.valor || '',
                idEmpresa: data.idEmpresa || '',
                activo: data.activo ?? true
            });
        } else {
            setForm({
                nombre: '',
                descripcion: '',
                valor: '',
                idEmpresa: '',
                activo: true
            });
        }
    }, [mode, data]);

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = () => {
        onSubmit(form, mode);
    };

    if (!open) return null;

    const Header = (
        <div
            className="roles-topbar"
            style={{
                marginBottom: '0.6rem',
                paddingRight: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: '0 0 auto',
            }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nueva Configuración' : 'Editar Configuración'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">
                ✕
            </button>
        </div>
    );

    const Body = (
        <div
            style={{
                paddingLeft: '5%',
                paddingRight: 16,
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '0.8rem',
                overflowY: 'auto',
                flex: '1 1 auto',
                minHeight: 0,
            }}>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre:</label>
                <br /><br />
                <input
                    className="infoField"
                    value={form.nombre}
                    onChange={(e) => handleChange('nombre', e.target.value)}
                    required
                    maxLength={100}
                />
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
                <br /><br />
                <input
                    className="infoField"
                    value={form.descripcion}
                    onChange={(e) => handleChange('descripcion', e.target.value)}
                    maxLength={250}
                />
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Valor (JSON/Configuración):</label>
                <br /><br />
                <textarea
                    className="infoField"
                    style={{ minHeight: '150px', fontFamily: 'monospace', paddingTop: '10px' }}
                    value={form.valor}
                    onChange={(e) => handleChange('valor', e.target.value)}
                    placeholder='{"--color-primary": "#BE0032", ...}'
                />
            </div>

            {empresas.length > 0 && (
                <div>
                    <label className="roles-title" style={{ fontSize: '.95rem' }}>Empresa (Opcional - Global si está vacío):</label>
                    <br /><br />
                    <select
                        className="infoField"
                        value={form.idEmpresa || ''}
                        onChange={(e) => handleChange('idEmpresa', e.target.value ? Number(e.target.value) : '')}
                    >
                        <option value="">-- Configuración Global --</option>
                        {empresas.map((emp) => (
                            <option key={emp.idEmpresa} value={emp.idEmpresa}>
                                {emp.nombre}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );


    const Footer = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '.6rem',
                marginTop: '.8rem',
                paddingRight: 16,
                flex: '0 0 auto',
            }}
        >
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={handleSubmit}
                disabled={!form.nombre}
                style={{
                    opacity: !form.nombre ? 0.5 : 1,
                    cursor: !form.nombre ? 'not-allowed' : 'pointer',
                }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    return (
        <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {Header}
            {Body}
            {Footer}
        </div>
    );
}
